import React from "react";
import { connect } from "react-redux";
import { Card, CardHeader, CardBody } from "reactstrap";
import "./custom.styles.scss";
import classNames from "classnames";
import { translate } from "react-i18next";

class DeviceStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datetime: "",
      basicData: "",
      devices: "",
      latestData: "",
      time: 0,
      activeStatus: [],
    };
  }

  componentDidMount() {
    // only purpose is to rerender every 10 seconds
    this.interval = setInterval(
      () => this.setState({ time: this.state.time + 1 }),
      1000
    );
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.datetime !== this.props.datetime) {
      this.setState({
        ...this.state,
        datetime: this.props.datetime,
        time: 0,
      });
    }
    if (prevProps.basicData !== this.props.basicData) {
      this.setState({
        ...this.state,
        basicData: this.props.basicData,
        time: 0,
      });
    }

    if (prevProps.activeStatus !== this.props.activeStatus) {
      this.setState({
        ...this.state,
        activeStatus: this.props.activeStatus,
      });
    }

    if (prevProps.devices !== this.props.devices) {
      if (this.props.devices.length === 0) {
        this.setState({
          ...this.state,
          basicData: "",
          time: 0,
        });
      }
    }

    if (prevProps.latestData !== this.props.latestData) {
      this.setState({
        ...this.state,
        latestData: this.props.latestData,
        time: 0,
      });
    }
  }
  exactChecking = (latestData, basicData, key) => {
    if (key.forcedValue) {
      return key.error;
    }
    if (this.props.devices && this.props.devices.length > 0) {
      if (
        basicData &&
        basicData[key.name] !== undefined &&
        basicData[key.name] !== null
      ) {
        if (basicData[key.name] === key.value) {
          return key.main;
        }
      } else if (
        latestData &&
        latestData[key.name] !== undefined &&
        latestData[key.name] !== null
      ) {
        if (latestData[key.name] === key.value) {
          return key.main;
        }
      }
      return key.error;
    }
    return key.error;
  };
  lessthanData = (latestData, basicData, key) => {
    if (this.props.devices && this.props.devices.length > 0) {
      if (
        basicData &&
        basicData[key.name] !== undefined &&
        basicData[key.name] !== null
      ) {
        if (!(basicData[key.name] >= key.value)) {
          return key.main;
        }
      } else if (
        latestData &&
        latestData[key.name] !== undefined &&
        latestData[key.name] !== null
      ) {
        if (!(latestData[key.name] >= key.value)) {
          return key.main;
        }
      }
      return key.error;
    }
    return key.error;
  };
  forDoor = (latestData, basicData) => {
    if (this.props.devices && this.props.devices.length > 0) {
      if (basicData) {
        if (typeof basicData.w === "number" && basicData.w < 2) {
          return true;
        } else if (typeof basicData.d === "number" && basicData.d < 2) {
          return false;
        }
      } else if (latestData) {
        if (latestData.w && latestData.w === 2) {
          return true;
        } else if (typeof latestData.d === "number" && latestData.d < 2) {
          return false;
        }
        return true;
      }
      return true;
    } else {
      return true;
    }
  };

  waterIcon = (filteredBasicData) => {
    const { latestData, basicData } = this.props;
    const NODE_TYPE =
      filteredBasicData &&
      filteredBasicData.length > 0 &&
      filteredBasicData[0].Node_Type === 2;
    return (
      <div
        className={`d-flex  flex-column justify-content-center ${classNames({
          op03: this.lessthanData(latestData, basicData, {
            name: "w",
            value: 2,
            main: false,
            error: filteredBasicData
              ? filteredBasicData.length === 0 ||
                (filteredBasicData.length > 0 &&
                  (NODE_TYPE
                    ? filteredBasicData[0].water_s
                    : filteredBasicData[0].w) === 2)
                ? true
                : false
              : true,
          }),
        })}`}
      >
        <div className={`custom_iconbox d-flex  align-items-center `}>
          {filteredBasicData &&
          filteredBasicData.length > 0 &&
          (NODE_TYPE
            ? filteredBasicData[0].water_s
            : filteredBasicData[0].w) === 1 ? (
            <svg
              className={classNames({
                "d-none": this.exactChecking(latestData, basicData, {
                  name: "w",
                  value: 0,
                  main: true,
                  error: false,
                }),
              })}
              width="43"
              height="43"
              viewBox="0 0 68 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27.0082 47.8483C23.3343 47.0728 19.9476 44.4195 18.22 40.9631C15.9448 36.4113 16.3228 31.517 19.4432 25.1274C20.6656 22.6243 21.7553 20.7901 24.6421 16.3759C27.253 12.3836 28.3897 10.5182 29.0756 9.09974C29.357 8.51759 29.6376 8.02308 29.6988 8.00081C29.7605 7.97873 30.0264 8.41154 30.2909 8.96298C31.0063 10.4558 32.0878 12.2453 34.5606 16.0287C37.4864 20.5047 38.912 22.8959 40.0775 25.2819C43.1234 31.5177 43.4689 36.4688 41.1764 41.0327C39.7803 43.8121 37.1806 46.1673 34.2315 47.3244C32.2116 48.1171 29.2865 48.3293 27.0082 47.8483ZM26.4406 44.7214C24.8461 43.4772 23.5134 41.3042 22.5562 38.3894C21.4058 34.8861 21.3034 31.4028 22.2059 26.476C22.378 25.537 22.4714 24.8181 22.4144 24.8786C22.3569 24.9389 22.1227 25.3635 21.8941 25.822C19.7392 30.1431 19.0275 33.0238 19.3693 36.0421C19.8181 40.0074 22.3284 43.4111 25.882 44.8729C26.9786 45.3239 27.1525 45.277 26.4408 44.7214L26.4406 44.7214Z"
                fill="#fff"
              />
              <path
                d="M39.3897 31.0358L40.0941 49.9694H35.2266L43.0368 60.5292L50.3566 49.9694L45.6126 50.3215L45.4764 30.9883"
                stroke="#fff"
                strokeWidth="1.22658"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              className={classNames({
                "d-none": this.exactChecking(latestData, basicData, {
                  name: "w",
                  value: 0,
                  main: true,
                  error: false,
                }),
              })}
              width="43"
              height="43"
              viewBox="0 0 68 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M30.7015 60.2954C25.788 59.2582 21.2584 55.7095 18.9478 51.0868C15.9048 44.9989 16.4104 38.453 20.5838 29.9071C22.2187 26.5594 23.6761 24.1062 27.537 18.2025C31.029 12.8629 32.5493 10.3681 33.4666 8.47086C33.843 7.69225 34.2183 7.03087 34.3002 7.00108C34.3826 6.97155 34.7384 7.55041 35.0922 8.28794C36.049 10.2845 37.4954 12.6779 40.8027 17.738C44.7157 23.7245 46.6223 26.9227 48.1812 30.1138C52.255 38.4539 52.7171 45.0758 49.6509 51.1798C47.7837 54.8972 44.3068 58.0472 40.3625 59.5947C37.661 60.6549 33.7487 60.9388 30.7015 60.2954ZM29.9425 56.1133C27.81 54.4492 26.0275 51.5429 24.7472 47.6446C23.2086 42.959 23.0717 38.3002 24.2788 31.7109C24.5089 30.455 24.6339 29.4935 24.5577 29.5744C24.4808 29.6551 24.1675 30.223 23.8618 30.8361C20.9797 36.6155 20.0278 40.4683 20.4849 44.5051C21.0852 49.8086 24.4426 54.3609 29.1954 56.3159C30.6621 56.9192 30.8945 56.8564 29.9427 56.1133L29.9425 56.1133Z"
                fill="#fff "
              />
            </svg>
          )}

          <p className="m-0">{this.props.t("dashboard.water")}</p>
        </div>
      </div>
    );
  };

  batteryIcon = (filteredBasicData) => {
    const { latestData, basicData } = this.props;
    const NODE_TYPE =
      filteredBasicData &&
      filteredBasicData.length > 0 &&
      filteredBasicData[0].Node_Type === 2;

    return (
      <div
        className={`d-flex  flex-column justify-content-center ${classNames({
          op03: this.exactChecking(latestData, basicData, {
            name: "m",
            value: 3,
            main: false,
            error: NODE_TYPE
              ? filteredBasicData &&
                filteredBasicData.length > 0 &&
                filteredBasicData[0].BV &&
                filteredBasicData[0].BV !== -255
                ? false
                : true
              : this.props.devices &&
                this.props.devices.length > 0 &&
                filteredBasicData &&
                filteredBasicData.length > 0 &&
                filteredBasicData[0].m
              ? filteredBasicData[0].m === -255
                ? true
                : filteredBasicData[0].m === 3
                ? false
                : true
              : true,
          }),
        })}`}
      >
        <div className={`custom_iconbox d-flex  align-items-center `}>
          <svg
            width="43"
            height="43"
            viewBox="0 0 68 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M39.6525 11.3419V11.8419H40.1525H44.7222C45.5543 11.846 46.3511 12.1793 46.9383 12.769L46.9384 12.769C47.5273 13.3602 47.8596 14.1596 47.8632 14.9939V57.0858C47.8589 57.9228 47.5237 58.7242 46.9307 59.3151C46.3374 59.9061 45.5342 60.2384 44.6967 60.2392H24.6398C22.9233 60.2392 21.5 58.8177 21.5 57.0608V14.9877C21.5036 14.1533 21.8359 13.3539 22.4248 12.7628L22.4248 12.7627C23.0121 12.173 23.8088 11.8398 24.641 11.8356H29.2107H29.7107V11.3356V7.5H39.6525V11.3419Z"
              stroke="white"
            />
            <rect
              x="45"
              y="57"
              width="21"
              height="43"
              transform="rotate(-180 45 57)"
              fill="white"
            />
          </svg>
          <p className="m-0">
            {NODE_TYPE
              ? filteredBasicData &&
                filteredBasicData.length > 0 &&
                filteredBasicData[0].BV
                ? `${filteredBasicData[0].BV} %`
                : "N/A"
              : this.props.devices &&
                this.props.devices.length > 0 &&
                filteredBasicData &&
                filteredBasicData.length > 0 &&
                filteredBasicData[0].m
              ? filteredBasicData[0].m === -255
                ? "N/A"
                : filteredBasicData[0].m === 3
                ? `${filteredBasicData[0].b} %`
                : "N/A"
              : "N/A"}
          </p>
        </div>
      </div>
    );
  };

  render() {
    const {
      basicData,
      deviceId,
      deviceName,
      latestData,
      activeStatus,
      devices,
      userInfo,
      convertToFeherenheit,
      t,
    } = this.props;

    const filteredDataStatus =
      basicData &&
      basicData.length > 0 &&
      basicData.filter((eachDevice) => eachDevice.id === deviceId);
    const deviceStatusValue =
      this.props.deviceStatusData && this.props.deviceStatusData.nodeData;
    const filteredBasicData =
      !!filteredDataStatus && filteredDataStatus.length > 0
        ? filteredDataStatus
        : !!deviceStatusValue && [deviceStatusValue];

    const filteredActiveStatus =
      activeStatus &&
      activeStatus.filter((eachDevice) => eachDevice.device_id === deviceId);

    var currentDevice = [];
    if (devices && devices.length > 0) {
      currentDevice = devices.filter(
        (eachDevice) => eachDevice.deviceId === deviceId
      );
    }

    const shouldConvertToFeherenheit = this.props.temperatureUnit;

    return (
      <Card
        style={{
          height: "125px", // Adjust these values as needed
          transition: "height 0.3s ease-in-out",
          width: "100%",
          marginBottom: "0.35rem !important",
          border: "1px solid var(--dropdown-border-bg)",
        }}
        className="recent-alarms"
      >
        <CardHeader className="device-status__header">
          <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-between">
              <p>{deviceName !== "" ? deviceName : ""}</p>
              <div
                style={{
                  marginLeft: "10px",
                }}
              >
                {(this.props.devices && this.props.devices.length > 0) ||
                (this.props.deviceStatusData &&
                  this.props.deviceStatusData.status) ? (
                  <>
                    {((filteredActiveStatus &&
                      filteredActiveStatus.length > 0 &&
                      filteredActiveStatus[0].status) ||
                      (currentDevice &&
                        currentDevice.length > 0 &&
                        currentDevice[0].status)) === "active" ? (
                      <div className="status">
                        <div className="green-circle" />
                        <p>{t("dashboar.online")}</p>
                      </div>
                    ) : (
                      <div className="status">
                        <div className="red-circle" />
                        <p>{t("dashboard.offline")}</p>
                      </div>
                    )}
                  </>
                ) : (
                  "N/A"
                )}
              </div>
            </div>
            <p>
              {deviceId !== ""
                ? deviceId
                    .toUpperCase()
                    .match(/.{1,2}/g)
                    .join(":")
                : ""}
            </p>
          </div>
        </CardHeader>
        <div
          style={{
            height: "1px",
            width: "100%",
            backgroundColor: "#ccc",
            color: "transparent",
          }}
        >
          <span>title</span>
        </div>
        <CardBody className="card-body">
          <>
            {filteredBasicData.length &&
            !!filteredBasicData[0].Node_Type &&
            filteredBasicData[0].Node_Type === 2 ? (
              <div className="custom_status__icon__container mb-2 mt-2">
                {this.batteryIcon(filteredBasicData)}
                {this.waterIcon(filteredBasicData)}
              </div>
            ) : filteredBasicData.length &&
              !!filteredBasicData[0].Node_Type &&
              filteredBasicData[0].Node_Type === 1 ? (
              <div className="single_custom_status__icon__container mb-2 mt-2">
                <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03: this.exactChecking(latestData, basicData, {
                        name: "m",
                        value: 3,
                        main: false,
                        error:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData &&
                          filteredBasicData.length > 0 &&
                          filteredBasicData[0].sht_t
                            ? filteredBasicData[0].sht_t === -255
                              ? true
                              : false
                            : true,
                      }),
                    }
                  )}`}
                >
                  <div
                    className={`single_custom_iconbox d-flex  align-items-center `}
                  >
                    <svg
                      width="43"
                      height="43"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M31.8427 53.781C29.9625 53.1101 28.7148 51.3123 28.7148 49.2746C28.7148 47.3474 29.5152 45.9445 31.1651 44.9806L32.1514 44.4042L32.2426 29.0825C32.2947 20.6556 32.3507 13.743 32.3748 13.7212C32.3944 13.7015 32.6581 13.5564 32.9538 13.4034C33.5646 13.0875 34.0357 13.1813 34.5371 13.7192C34.8757 14.0833 34.8842 14.4221 34.8842 29.2948V44.4984L35.6331 44.8319C37.9673 45.871 39.0651 49.0657 37.884 51.3812C36.7999 53.506 34.0901 54.5825 31.8436 53.7807L31.8427 53.781Z"
                        fill="white"
                      />
                      <path
                        d="M30.7304 60.0143C26.7735 59.057 23.2958 55.5772 22.2682 51.5465C21.9106 50.144 21.9106 47.3601 22.2682 45.9577C22.8445 43.6957 24.3333 41.3311 26.0406 39.9649L26.7322 39.4112V26.0552C26.7322 13.034 26.7517 12.6721 27.106 11.6178C27.7939 9.57597 29.1226 8.17953 31.1208 7.39857C32.5063 6.85738 34.5391 6.86846 35.9944 7.42486C37.4485 7.98167 39.2053 9.72977 39.7998 11.2108L40.2244 12.2683L40.2765 25.7737L40.3286 39.2791L41.7105 40.6816C45.2619 44.2859 46.0686 49.3566 43.8214 53.95C43.2301 55.1592 42.796 55.7377 41.5711 56.9501C39.8935 58.6105 38.2689 59.547 36.2333 60.0268C34.8456 60.3537 32.1081 60.3472 30.7272 60.0134L30.7304 60.0143ZM36.1435 57.122C37.5508 56.6877 39.2001 55.6097 40.1395 54.5114C43.3721 50.7315 42.7878 44.9024 38.8733 41.877C38.2637 41.4061 37.7262 40.9894 37.6776 40.9505C37.632 40.9118 37.5493 34.5156 37.5018 26.7371L37.4132 12.5941L36.8798 11.7316C36.1003 10.471 34.937 9.79974 33.5496 9.81008C31.789 9.82327 30.1771 10.9768 29.7438 12.5339C29.6396 12.9097 29.5719 18.5113 29.5719 26.8673L29.5709 40.5838L29.0779 41.0553C28.8064 41.3145 28.2205 41.8203 27.7758 42.1795C24.6803 44.6801 23.8757 49.6206 25.9795 53.2104C27.9931 56.6463 32.3085 58.3071 36.1445 57.1223L36.1435 57.122Z"
                        fill="white"
                      />
                    </svg>

                    <p className="m-0">
                      {this.props.devices &&
                      this.props.devices.length > 0 &&
                      filteredBasicData &&
                      filteredBasicData.length > 0 &&
                      filteredBasicData[0].sht_t
                        ? filteredBasicData[0].sht_t === -255
                          ? "N/A"
                          : shouldConvertToFeherenheit === "Celsius"
                          ? `${Number(filteredBasicData[0].sht_t).toFixed(
                              2
                            )} °C`
                          : `${convertToFeherenheit(
                              Number(filteredBasicData[0].sht_t)
                            ).toFixed(2)} °F`
                        : "N/A"}{" "}
                    </p>
                  </div>
                  {/* <div className="ml-2">Onboard</div> */}
                </div>
                <div
                  className={`d-flex  flex-column justify-content-center `}
                  style={
                    window.innerWidth > 550
                      ? {
                          padding: "0px 20%",
                          borderLeft: "1px solid #ccc",
                          borderRight: "1px solid #ccc",
                        }
                      : {}
                  }
                >
                  <div
                    className={`single_custom_iconbox d-flex  align-items-center ${classNames(
                      {
                        op03: this.exactChecking(latestData, basicData, {
                          name: "m",
                          value: 3,
                          main: false,
                          error:
                            this.props.devices &&
                            this.props.devices.length > 0 &&
                            filteredBasicData &&
                            filteredBasicData.length > 0 &&
                            filteredBasicData[0].thermo
                              ? filteredBasicData[0].thermo === -255
                                ? true
                                : false
                              : true,
                        }),
                      }
                    )}`}
                  >
                    <svg
                      width="43"
                      height="43"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M31.8427 53.781C29.9625 53.1101 28.7148 51.3123 28.7148 49.2746C28.7148 47.3474 29.5152 45.9445 31.1651 44.9806L32.1514 44.4042L32.2426 29.0825C32.2947 20.6556 32.3507 13.743 32.3748 13.7212C32.3944 13.7015 32.6581 13.5564 32.9538 13.4034C33.5646 13.0875 34.0357 13.1813 34.5371 13.7192C34.8757 14.0833 34.8842 14.4221 34.8842 29.2948V44.4984L35.6331 44.8319C37.9673 45.871 39.0651 49.0657 37.884 51.3812C36.7999 53.506 34.0901 54.5825 31.8436 53.7807L31.8427 53.781Z"
                        fill="white"
                      />
                      <path
                        d="M30.7304 60.0143C26.7735 59.057 23.2958 55.5772 22.2682 51.5465C21.9106 50.144 21.9106 47.3601 22.2682 45.9577C22.8445 43.6957 24.3333 41.3311 26.0406 39.9649L26.7322 39.4112V26.0552C26.7322 13.034 26.7517 12.6721 27.106 11.6178C27.7939 9.57597 29.1226 8.17953 31.1208 7.39857C32.5063 6.85738 34.5391 6.86846 35.9944 7.42486C37.4485 7.98167 39.2053 9.72977 39.7998 11.2108L40.2244 12.2683L40.2765 25.7737L40.3286 39.2791L41.7105 40.6816C45.2619 44.2859 46.0686 49.3566 43.8214 53.95C43.2301 55.1592 42.796 55.7377 41.5711 56.9501C39.8935 58.6105 38.2689 59.547 36.2333 60.0268C34.8456 60.3537 32.1081 60.3472 30.7272 60.0134L30.7304 60.0143ZM36.1435 57.122C37.5508 56.6877 39.2001 55.6097 40.1395 54.5114C43.3721 50.7315 42.7878 44.9024 38.8733 41.877C38.2637 41.4061 37.7262 40.9894 37.6776 40.9505C37.632 40.9118 37.5493 34.5156 37.5018 26.7371L37.4132 12.5941L36.8798 11.7316C36.1003 10.471 34.937 9.79974 33.5496 9.81008C31.789 9.82327 30.1771 10.9768 29.7438 12.5339C29.6396 12.9097 29.5719 18.5113 29.5719 26.8673L29.5709 40.5838L29.0779 41.0553C28.8064 41.3145 28.2205 41.8203 27.7758 42.1795C24.6803 44.6801 23.8757 49.6206 25.9795 53.2104C27.9931 56.6463 32.3085 58.3071 36.1445 57.1223L36.1435 57.122Z"
                        fill="white"
                      />
                    </svg>

                    <p className="m-0">
                      {this.props.devices &&
                      this.props.devices.length > 0 &&
                      filteredBasicData &&
                      filteredBasicData.length > 0 &&
                      filteredBasicData[0].thermo
                        ? filteredBasicData[0].thermo === -255
                          ? "N/A"
                          : shouldConvertToFeherenheit === "Celsius"
                          ? `${Number(filteredBasicData[0].thermo).toFixed(
                              2
                            )}  °C`
                          : `${convertToFeherenheit(
                              Number(filteredBasicData[0].thermo)
                            ).toFixed(2)} °F`
                        : "N/A"}{" "}
                    </p>
                  </div>
                  {/* <div className="ml-2">Thermocouple</div> */}
                </div>
                {/* <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03: this.exactChecking(latestData, basicData, {
                        name: "m",
                        value: 3,
                        main: false,
                        error:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData &&
                          filteredBasicData.length > 0 &&
                          filteredBasicData[0].bmp_s
                            ? filteredBasicData[0].bmp_s === -255
                              ? true
                              : false
                            : true,
                        forcedValue:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData &&
                          filteredBasicData.length > 0 &&
                          filteredBasicData[0].bmp_s
                            ? filteredBasicData[0].bmp_s === -255
                              ? true
                              : false
                            : true,
                      }),
                    }
                  )}`}
                >
                  <div
                    className={`custom_iconbox d-flex  align-items-center justify-content-center `}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="43"
                      height="43"
                      viewBox="0 0 4096 4096"
                      version="1.1"
                    >
                      <path
                        d=""
                        stroke="none"
                        fill="#fff"
                        fill-rule="evenodd"
                      />
                      <path
                        d="M 2025.555 385.614 C 2015.820 387.371, 1999.338 392.802, 1990.829 397.056 C 1960.615 412.160, 1937.293 439.020, 1926.588 471.041 C 1919.389 492.573, 1920 435.989, 1920 1081.631 L 1920 1664 1782.131 1664 C 1629.619 1664, 1636.560 1663.728, 1616.329 1670.492 C 1598.039 1676.606, 1582.855 1685.648, 1569.015 1698.668 C 1548.853 1717.635, 1535.459 1742.546, 1530.496 1770.307 C 1527.732 1785.771, 1528.757 1808.686, 1532.919 1824.464 C 1536.357 1837.495, 1542.269 1850.962, 1549.252 1861.664 C 1551.705 1865.424, 1642.177 1992.250, 1750.301 2143.500 C 1890.904 2340.184, 1949.255 2421.045, 1955.195 2427.436 C 1997.753 2473.225, 2067.749 2481.317, 2120 2446.487 C 2128.642 2440.727, 2138.696 2431.898, 2145.201 2424.358 C 2150.013 2418.781, 2537.620 1877.552, 2547.873 1862.094 C 2561.455 1841.617, 2568.368 1817.976, 2568.368 1792 C 2568.368 1755.773, 2555.157 1724.753, 2529.062 1699.706 C 2510.305 1681.703, 2489.378 1670.872, 2463.754 1665.905 C 2454.384 1664.088, 2447.501 1664, 2314.965 1664 L 2176 1664 2176 1081.631 C 2176 560.819, 2175.837 498.323, 2174.454 490.381 C 2166.337 443.739, 2133.581 405.505, 2088.959 390.588 C 2083.207 388.665, 2074.504 386.396, 2069.619 385.546 C 2058.575 383.623, 2036.390 383.658, 2025.555 385.614 M 3269.500 2049.584 C 3073.749 2067.206, 2903.012 2183.204, 2815.476 2358.048 C 2804.435 2380.101, 2800.567 2389.591, 2797.264 2402.726 C 2794.804 2412.508, 2794.555 2415.204, 2794.555 2432 C 2794.555 2448.796, 2794.804 2451.492, 2797.264 2461.274 C 2805.469 2493.904, 2823.929 2520.527, 2850.713 2538.358 C 2872.948 2553.160, 2895.477 2560, 2922 2560 C 2957.700 2560, 2987.939 2547.409, 3013.007 2522.105 C 3025.957 2509.034, 3030.128 2502.804, 3042.894 2477.471 C 3054.315 2454.806, 3062.181 2441.860, 3074.342 2425.713 C 3124.852 2358.645, 3200.952 2315.511, 3285.500 2306.026 C 3298.684 2304.547, 3306.033 2304.761, 3319.931 2307.029 C 3469.831 2331.486, 3578.390 2466.387, 3569.953 2617.716 C 3568.557 2642.750, 3567.555 2648.272, 3562.548 2658.500 C 3549.703 2684.738, 3532.331 2708.699, 3509.541 2731.612 C 3486.425 2754.853, 3463.451 2771.301, 3433.500 2786.051 C 3397.830 2803.617, 3363.920 2812.490, 3322.924 2814.983 C 3312.118 2815.640, 2804.460 2815.985, 1838.881 2815.991 C 519.582 2815.999, 370.364 2816.156, 362.381 2817.546 C 322.283 2824.524, 287.172 2850.590, 269.056 2886.829 C 264.608 2895.725, 259.368 2911.911, 257.546 2922.381 C 255.565 2933.762, 255.565 2954.238, 257.546 2965.619 C 265.663 3012.261, 298.419 3050.495, 343.041 3065.412 C 348.793 3067.335, 357.496 3069.604, 362.381 3070.454 C 370.365 3071.844, 520.835 3072, 1851.931 3072 C 2865.673 3072, 3336.842 3071.673, 3346.050 3070.962 C 3379.173 3068.406, 3407.211 3063.969, 3437.805 3056.440 C 3590.589 3018.840, 3719.774 2916.079, 3790.987 2775.500 C 3802.430 2752.911, 3810.268 2734.690, 3813.565 2723.014 C 3818.405 2705.873, 3823.852 2669.651, 3825.973 2640.500 C 3827.283 2622.504, 3827.283 2581.496, 3825.973 2563.500 C 3817.224 2443.254, 3772.300 2333.741, 3693.314 2240.111 C 3680.796 2225.273, 3650.003 2194.379, 3634.500 2181.105 C 3556.239 2114.096, 3460.855 2069.615, 3361 2053.563 C 3325.125 2047.796, 3301.013 2046.748, 3269.500 2049.584 M 361.555 3201.614 C 351.820 3203.371, 335.338 3208.802, 326.829 3213.056 C 296.615 3228.160, 273.293 3255.020, 262.588 3287.041 C 257.869 3301.156, 256 3312.777, 256 3328 C 256 3361.342, 268.062 3391.955, 290.668 3415.985 C 309.341 3435.835, 335.248 3449.732, 362.381 3454.454 C 370.368 3455.844, 540.045 3456, 2048 3456 C 3555.955 3456, 3725.632 3455.844, 3733.619 3454.454 C 3773.717 3447.476, 3808.828 3421.410, 3826.944 3385.171 C 3831.392 3376.275, 3836.632 3360.089, 3838.454 3349.619 C 3840.435 3338.238, 3840.435 3317.762, 3838.454 3306.381 C 3830.337 3259.739, 3797.581 3221.505, 3752.959 3206.588 C 3747.207 3204.665, 3738.504 3202.396, 3733.619 3201.546 C 3725.631 3200.155, 3556.131 3200.009, 2047.119 3200.090 C 594.695 3200.167, 368.433 3200.372, 361.555 3201.614 M 361.555 3585.614 C 351.820 3587.371, 335.338 3592.802, 326.829 3597.056 C 296.615 3612.160, 273.293 3639.020, 262.588 3671.041 C 257.869 3685.156, 256 3696.777, 256 3712 C 256 3745.342, 268.062 3775.955, 290.668 3799.985 C 309.341 3819.835, 335.248 3833.732, 362.381 3838.454 C 370.368 3839.844, 540.045 3840, 2048 3840 C 3555.955 3840, 3725.632 3839.844, 3733.619 3838.454 C 3773.717 3831.476, 3808.828 3805.410, 3826.944 3769.171 C 3831.392 3760.275, 3836.632 3744.089, 3838.454 3733.619 C 3840.435 3722.238, 3840.435 3701.762, 3838.454 3690.381 C 3830.337 3643.739, 3797.581 3605.505, 3752.959 3590.588 C 3747.207 3588.665, 3738.504 3586.396, 3733.619 3585.546 C 3725.631 3584.155, 3556.131 3584.009, 2047.119 3584.090 C 594.695 3584.167, 368.433 3584.372, 361.555 3585.614"
                        stroke="none"
                        fill="#fff"
                        fill-rule="evenodd"
                      />
                    </svg>

                    <p className="m-0">
                      {this.props.devices &&
                      this.props.devices.length > 0 &&
                      filteredBasicData &&
                      filteredBasicData.length > 0 &&
                      filteredBasicData[0].bmp_s
                        ? filteredBasicData[0].bmp_s === -255
                          ? "N/A"
                          : `${Number(filteredBasicData[0].bmp_s).toFixed(
                              2
                            )} hPa`
                        : "N/A"}{" "}
                    </p>
                  </div>
                </div> */}

                <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03: this.exactChecking(latestData, basicData, {
                        name: "m",
                        value: 3,
                        main: false,
                        error:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData &&
                          filteredBasicData.length > 0 &&
                          filteredBasicData[0].sht_rh
                            ? filteredBasicData[0].sht_rh === -255
                              ? true
                              : false
                            : true,
                      }),
                    }
                  )}`}
                >
                  <div
                    className={`d-flex  flex-column justify-content-center `}
                  >
                    <div
                      className={`single_custom_iconbox d-flex  align-items-center `}
                    >
                      <svg
                        width="43"
                        height="43"
                        viewBox="0 0 68 68"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M30.0411 60.3997C18.9387 58.0249 11.8068 46.7445 14.6118 35.9945C15.8456 31.2662 18.0725 27.5293 24.8864 18.7539C28.9015 13.5831 30.9354 10.7886 32.095 8.8498C32.4983 8.17559 32.9855 7.4819 33.1777 7.30812C33.5915 6.93363 34.73 6.89052 35.1435 7.23383C35.3042 7.36767 36.0604 8.43451 36.8243 9.60645C38.44 12.0848 40.0956 14.33 44.2176 19.6322C49.9113 26.9562 51.9733 30.317 53.3896 34.5814C54.2216 37.086 54.4915 39.0708 54.3614 41.7272C53.9092 50.9636 47.0942 58.7444 37.9347 60.4819C35.8943 60.8691 32.0486 60.829 30.0411 60.399V60.3997ZM41.463 53.7005C43.3032 52.8375 44.3419 51.1535 44.3405 49.0361C44.3401 47.9947 44.2446 47.5591 43.8451 46.7949C41.6818 42.6451 35.6743 43.2652 34.3637 47.7736C33.8712 49.4679 34.2633 51.071 35.504 52.4452C37.0736 54.1827 39.3936 54.6714 41.463 53.7005ZM35.4669 41.7597L44.4975 32.7291L44.3836 32.0194C44.2363 31.0923 43.5404 30.479 42.6365 30.479C41.9886 30.479 41.5676 30.87 33.0518 39.3792C26.9465 45.4795 24.1096 48.4378 24.034 48.7828C23.909 49.3521 24.3226 50.2989 24.8238 50.5909C25.0024 50.6932 25.4369 50.7805 25.7911 50.7851C26.3973 50.7851 26.9678 50.2584 35.466 41.7601L35.4669 41.7597ZM31.2683 36.7904C32.8338 35.9919 33.8397 34.7188 34.1919 33.0912C34.5749 31.3209 33.5982 29.0068 32.0232 27.9528C29.6337 26.3539 26.5252 26.9654 24.9047 29.3529C22.5574 32.8115 25.2347 37.5122 29.4003 37.2464C30.0355 37.2062 30.8376 37.0101 31.2683 36.7904V36.7904Z"
                          fill="white"
                        />
                        <path
                          d="M28.1482 33.4359C27.2198 32.7055 27.3626 31.2816 28.419 30.7351C30.0663 29.8832 31.5545 31.9484 30.2402 33.2625C29.5972 33.9055 28.8265 33.9693 28.1482 33.4365V33.4359Z"
                          fill="white"
                        />
                        <path
                          d="M38.6126 50.5289C37.5284 50.0565 37.3585 48.5767 38.3035 47.8335C38.9817 47.3001 39.7524 47.3639 40.3954 48.0075C41.2502 48.8624 41.0263 50.064 39.9267 50.5235C39.1746 50.8378 39.319 50.8371 38.6126 50.5235V50.5289Z"
                          fill="white"
                        />
                      </svg>

                      <p className="m-0">
                        {this.props.devices &&
                        this.props.devices.length > 0 &&
                        filteredBasicData &&
                        filteredBasicData.length > 0 &&
                        filteredBasicData[0].sht_rh
                          ? filteredBasicData[0].sht_rh === -255
                            ? "N/A"
                            : `${Number(filteredBasicData[0].sht_rh).toFixed(
                                2
                              )} %`
                          : "N/A"}{" "}
                      </p>
                    </div>
                    {/* <div className="ml-2">Onboard</div> */}
                  </div>
                </div>
                <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03: this.exactChecking(latestData, basicData, {
                        name: "m",
                        value: 3,
                        main: false,
                        error:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData &&
                          filteredBasicData.length > 0 &&
                          filteredBasicData[0].BV
                            ? filteredBasicData[0].BV === -255
                              ? true
                              : false
                            : true,
                      }),
                    }
                  )}`}
                  style={
                    window.innerWidth > 550
                      ? {
                          padding: "0px 20%",
                          borderLeft: "1px solid #ccc",
                          // borderRight: "1px solid #fff",
                        }
                      : {}
                  }
                >
                  <div
                    className={`single_custom_iconbox d-flex  align-items-center justify-content-center `}
                  >
                    <svg
                      width="43"
                      height="43"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M39.6525 11.3419V11.8419H40.1525H44.7222C45.5543 11.846 46.3511 12.1793 46.9383 12.769L46.9384 12.769C47.5273 13.3602 47.8596 14.1596 47.8632 14.9939V57.0858C47.8589 57.9228 47.5237 58.7242 46.9307 59.3151C46.3374 59.9061 45.5342 60.2384 44.6967 60.2392H24.6398C22.9233 60.2392 21.5 58.8177 21.5 57.0608V14.9877C21.5036 14.1533 21.8359 13.3539 22.4248 12.7628L22.4248 12.7627C23.0121 12.173 23.8088 11.8398 24.641 11.8356H29.2107H29.7107V11.3356V7.5H39.6525V11.3419Z"
                        stroke="white"
                      />
                      <rect
                        x="45"
                        y="57"
                        width="21"
                        height="43"
                        transform="rotate(-180 45 57)"
                        fill="white"
                      />
                    </svg>
                    <p className="m-0">
                      {this.props.devices &&
                      this.props.devices.length > 0 &&
                      filteredBasicData &&
                      filteredBasicData.length > 0 &&
                      (filteredBasicData[0].BV || filteredBasicData[0].BV === 0)
                        ? filteredBasicData[0].BV === -255
                          ? "N/A"
                          : `${filteredBasicData[0].BV} %`
                        : "N/A"}{" "}
                    </p>
                  </div>
                </div>
                {/* <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03:
                        this.props.devices &&
                        this.props.devices.length > 0 &&
                        filteredBasicData &&
                        filteredBasicData.length > 0 &&
                        filteredBasicData[0].light_s
                          ? filteredBasicData[0].light_s === -255
                            ? true
                            : false
                          : true,
                    }
                  )}`}
                >
                  <div
                    className={`custom_iconbox d-flex align-items-center  justify-content-center `}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="43"
                      height="43"
                      viewBox="0 0 4096 4096"
                      version="1.1"
                    >
                      <path
                        d=""
                        stroke="none"
                        fill="#fff"
                        fill-rule="evenodd"
                      />
                      <path
                        d="M 1920 448 L 1920 640 2048 640 L 2176 640 2176 448 L 2176 256 2048 256 L 1920 256 1920 448 M 3079 834.500 L 2943.502 970.001 3034.251 1060.749 L 3124.999 1151.498 3260.999 1015.501 L 3396.999 879.503 3306.752 789.252 C 3257.116 739.613, 3216.053 699, 3215.501 699 C 3214.949 699, 3153.523 759.975, 3079 834.500 M 787.748 790.752 L 697.001 881.503 833 1017.500 L 968.999 1153.497 1059.500 1063 C 1109.275 1013.227, 1150 972.053, 1150 971.501 C 1150 970.517, 879.979 700, 878.997 700 C 878.721 700, 837.659 740.838, 787.748 790.752 M 2000 1024.609 C 1996.975 1024.805, 1987.075 1025.445, 1978 1026.030 C 1762.920 1039.901, 1551.862 1125.380, 1387 1265.388 C 1355.917 1291.785, 1309.813 1336.528, 1285.389 1364 C 1126.756 1542.431, 1037.321 1759.590, 1024.900 1996.500 C 1023.580 2021.689, 1024.235 2098.755, 1025.951 2120 C 1033.433 2212.660, 1048.961 2290.883, 1075.974 2372 C 1180.161 2684.857, 1432.116 2930.915, 1747 3027.319 C 1828.697 3052.331, 1909.462 3066.501, 1996.500 3071.092 C 2021.669 3072.420, 2098.676 3071.770, 2120 3070.050 C 2261.714 3058.619, 2385.769 3024.694, 2506.035 2964.482 C 2780.503 2827.069, 2980.270 2572.105, 3047.428 2273.499 C 3063.533 2201.890, 3070.736 2139.278, 3071.700 2062.500 C 3072.382 2008.262, 3070.828 1974.939, 3065.455 1928.500 C 3028.284 1607.289, 2840.054 1322.203, 2557.500 1159.173 C 2534.605 1145.962, 2486.813 1121.623, 2464 1111.555 C 2356.041 1063.911, 2246.287 1036.265, 2126 1026.417 C 2107.807 1024.927, 2015.494 1023.603, 2000 1024.609 M 2018.858 1281.079 C 1895.809 1285.440, 1774.667 1319.997, 1667.500 1381.309 C 1459.167 1500.500, 1318.008 1710.382, 1287.038 1947 C 1276.188 2029.892, 1279.193 2119.933, 1295.477 2199.885 C 1311.450 2278.313, 1338.833 2352.517, 1377.074 2421 C 1491.190 2625.362, 1691.335 2766.746, 1920.500 2804.881 C 1952.343 2810.180, 1984.368 2813.560, 2011.500 2814.486 C 2020.300 2814.786, 2032.112 2815.264, 2037.750 2815.547 L 2048 2816.063 2048 2048.032 L 2048 1280 2044.250 1280.156 C 2042.188 1280.242, 2030.761 1280.658, 2018.858 1281.079 M 256 2048 L 256 2176 448 2176 L 640 2176 640 2048 L 640 1920 448 1920 L 256 1920 256 2048 M 3456 2048 L 3456 2176 3648 2176 L 3840 2176 3840 2048 L 3840 1920 3648 1920 L 3456 1920 3456 2048 M 872.310 3042.907 C 818.305 3097.133, 757.365 3158.522, 736.889 3179.327 L 699.658 3217.154 789.577 3307.077 C 839.032 3356.535, 879.947 3397, 880.499 3397 C 881.051 3397, 942.466 3336.035, 1016.977 3261.523 L 1152.451 3126.047 1138.979 3112.273 C 1103.445 3075.945, 971.760 2944.019, 971.170 2944.157 C 970.802 2944.243, 926.314 2988.681, 872.310 3042.907 M 3034.749 3034.751 L 2944.001 3125.503 3080.001 3261.501 L 3216.001 3397.498 3306.750 3306.749 L 3397.499 3216 3261.498 3079.999 L 3125.497 2943.998 3034.749 3034.751 M 1920 3648 L 1920 3840 2048 3840 L 2176 3840 2176 3648 L 2176 3456 2048 3456 L 1920 3456 1920 3648"
                        stroke="none"
                        fill="#fff"
                        fill-rule="evenodd"
                      />
                    </svg>

                    <p className="m-0">
                      {this.props.devices &&
                      this.props.devices.length > 0 &&
                      filteredBasicData &&
                      filteredBasicData.length > 0 &&
                      filteredBasicData[0].light_s
                        ? filteredBasicData[0].light_s === -255
                          ? "N/A"
                          : `${filteredBasicData[0].light_s} lux`
                        : "N/A"}{" "}
                    </p>
                  </div>
                </div> */}
              </div>
            ) : (
              <div className="custom_status__icon__container mb-2">
                <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03: this.exactChecking(latestData, basicData, {
                        name: "m",
                        value: 3,
                        main: false,
                        error:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData &&
                          filteredBasicData.length > 0 &&
                          filteredBasicData[0].t
                            ? filteredBasicData[0].t === -255
                              ? true
                              : false
                            : true,
                      }),
                    }
                  )}`}
                >
                  <div className={`custom_iconbox d-flex  align-items-center `}>
                    <svg
                      width="43"
                      height="43"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M31.8427 53.781C29.9625 53.1101 28.7148 51.3123 28.7148 49.2746C28.7148 47.3474 29.5152 45.9445 31.1651 44.9806L32.1514 44.4042L32.2426 29.0825C32.2947 20.6556 32.3507 13.743 32.3748 13.7212C32.3944 13.7015 32.6581 13.5564 32.9538 13.4034C33.5646 13.0875 34.0357 13.1813 34.5371 13.7192C34.8757 14.0833 34.8842 14.4221 34.8842 29.2948V44.4984L35.6331 44.8319C37.9673 45.871 39.0651 49.0657 37.884 51.3812C36.7999 53.506 34.0901 54.5825 31.8436 53.7807L31.8427 53.781Z"
                        fill="white"
                      />
                      <path
                        d="M30.7304 60.0143C26.7735 59.057 23.2958 55.5772 22.2682 51.5465C21.9106 50.144 21.9106 47.3601 22.2682 45.9577C22.8445 43.6957 24.3333 41.3311 26.0406 39.9649L26.7322 39.4112V26.0552C26.7322 13.034 26.7517 12.6721 27.106 11.6178C27.7939 9.57597 29.1226 8.17953 31.1208 7.39857C32.5063 6.85738 34.5391 6.86846 35.9944 7.42486C37.4485 7.98167 39.2053 9.72977 39.7998 11.2108L40.2244 12.2683L40.2765 25.7737L40.3286 39.2791L41.7105 40.6816C45.2619 44.2859 46.0686 49.3566 43.8214 53.95C43.2301 55.1592 42.796 55.7377 41.5711 56.9501C39.8935 58.6105 38.2689 59.547 36.2333 60.0268C34.8456 60.3537 32.1081 60.3472 30.7272 60.0134L30.7304 60.0143ZM36.1435 57.122C37.5508 56.6877 39.2001 55.6097 40.1395 54.5114C43.3721 50.7315 42.7878 44.9024 38.8733 41.877C38.2637 41.4061 37.7262 40.9894 37.6776 40.9505C37.632 40.9118 37.5493 34.5156 37.5018 26.7371L37.4132 12.5941L36.8798 11.7316C36.1003 10.471 34.937 9.79974 33.5496 9.81008C31.789 9.82327 30.1771 10.9768 29.7438 12.5339C29.6396 12.9097 29.5719 18.5113 29.5719 26.8673L29.5709 40.5838L29.0779 41.0553C28.8064 41.3145 28.2205 41.8203 27.7758 42.1795C24.6803 44.6801 23.8757 49.6206 25.9795 53.2104C27.9931 56.6463 32.3085 58.3071 36.1445 57.1223L36.1435 57.122Z"
                        fill="white"
                      />
                    </svg>

                    <p className="m-0">
                      {this.props.devices &&
                      this.props.devices.length > 0 &&
                      filteredBasicData &&
                      filteredBasicData.length > 0 &&
                      filteredBasicData[0].t
                        ? filteredBasicData[0].t === -255
                          ? "N/A"
                          : shouldConvertToFeherenheit === "Celsius"
                          ? `${Number(filteredBasicData[0].t).toFixed(2)}  °C`
                          : `${convertToFeherenheit(
                              Number(filteredBasicData[0].t)
                            ).toFixed(2)} °F`
                        : "N/A"}
                    </p>
                  </div>
                </div>
                <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03: this.exactChecking(latestData, basicData, {
                        name: "m",
                        value: 3,
                        main: false,
                        error:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData &&
                          filteredBasicData.length > 0 &&
                          filteredBasicData[0].h
                            ? filteredBasicData[0].h === -255
                              ? true
                              : false
                            : true,
                      }),
                    }
                  )}`}
                >
                  <div className={`custom_iconbox d-flex  align-items-center `}>
                    <svg
                      width="43"
                      height="43"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.0411 60.3997C18.9387 58.0249 11.8068 46.7445 14.6118 35.9945C15.8456 31.2662 18.0725 27.5293 24.8864 18.7539C28.9015 13.5831 30.9354 10.7886 32.095 8.8498C32.4983 8.17559 32.9855 7.4819 33.1777 7.30812C33.5915 6.93363 34.73 6.89052 35.1435 7.23383C35.3042 7.36767 36.0604 8.43451 36.8243 9.60645C38.44 12.0848 40.0956 14.33 44.2176 19.6322C49.9113 26.9562 51.9733 30.317 53.3896 34.5814C54.2216 37.086 54.4915 39.0708 54.3614 41.7272C53.9092 50.9636 47.0942 58.7444 37.9347 60.4819C35.8943 60.8691 32.0486 60.829 30.0411 60.399V60.3997ZM41.463 53.7005C43.3032 52.8375 44.3419 51.1535 44.3405 49.0361C44.3401 47.9947 44.2446 47.5591 43.8451 46.7949C41.6818 42.6451 35.6743 43.2652 34.3637 47.7736C33.8712 49.4679 34.2633 51.071 35.504 52.4452C37.0736 54.1827 39.3936 54.6714 41.463 53.7005ZM35.4669 41.7597L44.4975 32.7291L44.3836 32.0194C44.2363 31.0923 43.5404 30.479 42.6365 30.479C41.9886 30.479 41.5676 30.87 33.0518 39.3792C26.9465 45.4795 24.1096 48.4378 24.034 48.7828C23.909 49.3521 24.3226 50.2989 24.8238 50.5909C25.0024 50.6932 25.4369 50.7805 25.7911 50.7851C26.3973 50.7851 26.9678 50.2584 35.466 41.7601L35.4669 41.7597ZM31.2683 36.7904C32.8338 35.9919 33.8397 34.7188 34.1919 33.0912C34.5749 31.3209 33.5982 29.0068 32.0232 27.9528C29.6337 26.3539 26.5252 26.9654 24.9047 29.3529C22.5574 32.8115 25.2347 37.5122 29.4003 37.2464C30.0355 37.2062 30.8376 37.0101 31.2683 36.7904V36.7904Z"
                        fill="white"
                      />
                      <path
                        d="M28.1482 33.4359C27.2198 32.7055 27.3626 31.2816 28.419 30.7351C30.0663 29.8832 31.5545 31.9484 30.2402 33.2625C29.5972 33.9055 28.8265 33.9693 28.1482 33.4365V33.4359Z"
                        fill="white"
                      />
                      <path
                        d="M38.6126 50.5289C37.5284 50.0565 37.3585 48.5767 38.3035 47.8335C38.9817 47.3001 39.7524 47.3639 40.3954 48.0075C41.2502 48.8624 41.0263 50.064 39.9267 50.5235C39.1746 50.8378 39.319 50.8371 38.6126 50.5235V50.5289Z"
                        fill="white"
                      />
                    </svg>

                    <p className="m-0">
                      {this.props.devices &&
                      this.props.devices.length > 0 &&
                      filteredBasicData &&
                      filteredBasicData.length > 0 &&
                      filteredBasicData[0].h
                        ? filteredBasicData[0].h === -255
                          ? "N/A"
                          : `${Number(filteredBasicData[0].h).toFixed(2)} %`
                        : "N/A"}
                    </p>
                  </div>
                </div>
                <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03: this.exactChecking(latestData, basicData, {
                        name: "m",
                        value: 3,
                        main: false,
                        error:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData.length &&
                          typeof filteredBasicData[0].c === "number"
                            ? filteredBasicData[0].c === -255
                              ? true
                              : false
                            : true,
                        forcedValue:
                          this.props.devices &&
                          this.props.devices.length > 0 &&
                          filteredBasicData &&
                          filteredBasicData.length &&
                          typeof filteredBasicData[0].c === "number"
                            ? filteredBasicData[0].c === -255
                              ? true
                              : false
                            : true,
                      }),
                    }
                  )}`}
                >
                  <div className={`custom_iconbox d-flex  align-items-center `}>
                    <svg
                      width="43"
                      height="43"
                      viewBox="0 0 68 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.9879 59.841C11.2258 59.1277 8.26693 56.3423 7.25061 52.5572C6.91052 51.2899 6.91803 49.0808 7.26422 47.7759C7.78489 45.8316 8.96248 43.9887 10.5246 42.6736C11.3973 41.9391 13.1762 41.0131 14.2785 40.7196C15.3758 40.4273 17.4034 40.37 18.5475 40.5983C19.0798 40.7046 19.5841 40.8007 19.6683 40.8116C19.7596 40.825 21.4635 37.9938 23.9049 33.7736L27.9883 26.7154L27.2591 26.057C25.1886 24.1873 24.012 21.5562 24.012 18.7964C24.012 16.0739 24.927 13.817 26.8011 11.9173C28.7286 9.96332 31.0144 9.00328 33.7468 9.00001C38.2896 8.99501 42.078 11.9343 43.2705 16.3903C43.6003 17.623 43.6003 19.8703 43.2705 21.103C42.7586 23.0155 41.7971 24.6115 40.3574 25.9381L39.5067 26.7219L43.5842 33.777C46.0317 38.0119 47.7243 40.8262 47.8187 40.8175C47.9053 40.8105 48.3707 40.72 48.8532 40.6185C53.8143 39.5741 58.801 42.6625 60.2272 47.6627C60.583 48.9106 60.6334 50.8176 60.3458 52.2004C59.2906 57.2832 54.253 60.7396 49.1892 59.8554C41.9984 58.5995 38.6356 50.4204 42.8605 44.4624C43.5012 43.559 44.7419 42.4165 45.6281 41.9137C46.0145 41.6943 46.4008 41.4639 46.4867 41.4012C46.6107 41.3107 45.8474 39.9122 42.7457 34.5494C40.6023 30.8435 38.7761 27.7029 38.6876 27.5703L38.5267 27.329L37.7556 27.6793C36.5428 28.23 35.3108 28.4787 33.8023 28.4774C32.2643 28.4764 31.3216 28.2974 29.9594 27.7507C29.4129 27.5313 28.9295 27.3875 28.8856 27.4318C28.8446 27.4728 27.0172 30.6098 24.8312 34.3959L20.8567 41.2796L21.7227 41.784C22.896 42.4669 24.4934 44.0718 25.1891 45.2667C28.0731 50.22 26.1027 56.5899 20.928 59.0417C19.17 59.8746 16.8247 60.19 14.9845 59.8413L14.9879 59.841ZM18.9059 56.4385C23.5004 54.8408 24.8456 48.9757 21.4021 45.5559C20.0136 44.177 18.36 43.5502 16.3878 43.6553C15.1154 43.7236 14.1956 44.011 13.2045 44.6514C9.64032 46.9551 9.11414 51.8495 12.1087 54.8441C13.9149 56.6502 16.532 57.2641 18.9059 56.4385V56.4385ZM52.8172 56.4859C55.4181 55.6124 57.1508 53.3781 57.3362 50.6585C57.4234 49.3784 57.2463 48.4797 56.6697 47.2784C54.5055 42.7684 48.1126 42.3458 45.3154 46.5279C43.5196 49.213 43.8977 52.7471 46.2146 54.9328C46.6821 55.3737 47.3324 55.8449 47.7809 56.0676C48.4535 56.4016 48.7805 56.514 49.8003 56.7604C50.3277 56.8879 52.1004 56.7264 52.817 56.4858L52.8172 56.4859ZM35.5132 25.1015C36.3384 24.8759 37.4916 24.2628 38.1455 23.7018C38.4351 23.4538 38.9085 22.903 39.198 22.4784C41.2738 19.4337 40.4943 15.3068 37.4628 13.2914C36.355 12.5551 35.1471 12.1792 33.8657 12.1723C31.917 12.1586 30.5013 12.7448 29.1283 14.1228C27.7774 15.4787 27.2055 16.8539 27.2055 18.7464C27.2055 20.4869 27.7534 21.9202 28.8904 23.1515C30.6328 25.039 33.0922 25.7632 35.5132 25.1015Z"
                        fill="white"
                      />
                    </svg>

                    <p className="m-0">
                      {this.props.devices &&
                      this.props.devices.length > 0 &&
                      filteredBasicData &&
                      filteredBasicData.length > 0 &&
                      typeof filteredBasicData[0].c === "number"
                        ? filteredBasicData[0].c === -255
                          ? "N/A"
                          : `${Number(filteredBasicData[0].c).toFixed(2)} %`
                        : "N/A"}
                    </p>
                  </div>
                </div>
                {this.batteryIcon(filteredBasicData)}
                <div
                  className={`d-flex  flex-column justify-content-center ${classNames(
                    {
                      op03: !!filteredBasicData
                        ? filteredBasicData.length === 0 ||
                          (filteredBasicData.length > 0 &&
                            filteredBasicData[0].d === 2)
                          ? true
                          : false
                        : true,
                    }
                  )}`}
                >
                  <div className={`custom_iconbox d-flex align-items-center `}>
                    {filteredBasicData && filteredBasicData.length > 0 ? (
                      filteredBasicData[0].d === 1 ? (
                        <svg
                          width="43"
                          height="43"
                          viewBox="0 0 68 68"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7 44.4978H30.1269L18.5634 24.7266L7 44.4978ZM19.6147 41.3761H17.5122V39.2949H19.6147V41.3761ZM19.6147 37.2137H17.5122V33.0513H19.6147V37.2137Z"
                            fill="#B33545"
                          />
                          <path
                            d="M38.7043 58.2245C38.2539 58.2245 37.8518 58.0847 37.4982 57.8103C36.9847 57.415 36.728 56.8995 36.728 56.2538V12.9707C36.728 12.3299 36.9847 11.8095 37.4982 11.4144C37.8566 11.1397 38.2588 11 38.7043 11C38.8739 11 39.0484 11.0241 39.2178 11.0771L58.9974 15.0137C59.1427 15.0378 59.2686 15.0811 59.3849 15.1341C59.4963 15.1871 59.5835 15.2305 59.6513 15.2739C59.7191 15.3124 59.7821 15.3654 59.8499 15.4329C59.9177 15.5003 59.9614 15.5533 59.9905 15.5919L60.1116 15.7702C60.349 16.1123 60.4652 16.4929 60.4652 16.9121V52.3269C60.4652 52.8666 60.3393 53.2761 60.0873 53.5652C59.7821 53.9169 59.4238 54.1338 58.9974 54.2158L39.2178 58.1523C39.0435 58.2005 38.8739 58.2245 38.7043 58.2245ZM22.8779 31.6449V18.8732C22.8779 17.7842 23.2655 16.8543 24.0358 16.0882C24.806 15.3221 25.7409 14.9366 26.8357 14.9366H34.7465V18.8732H26.8357V38.0743L22.8779 31.6449ZM26.8357 44.7511V50.3514H34.7465V54.288H26.8357C25.7409 54.288 24.806 53.9025 24.0358 53.1363C23.2655 52.3703 22.8779 51.4404 22.8779 50.3514V44.7511"
                            fill="#fff"
                          />
                          <path
                            d="M43.6455 35.5978C44.188 35.5978 44.6531 35.4051 45.0407 35.0195C45.4283 34.6342 45.622 34.1715 45.622 33.6318C45.622 33.2801 45.5348 32.9477 45.3555 32.6489C45.1763 32.3453 44.9389 32.1092 44.6337 31.931C44.3285 31.7527 43.9991 31.666 43.6455 31.666C43.2869 31.666 42.9576 31.7527 42.6572 31.931C42.352 32.1092 42.1146 32.3453 41.9354 32.6489C41.7561 32.9525 41.6689 33.2801 41.6689 33.6318C41.6689 33.815 41.6932 33.9932 41.7367 34.1619C41.7852 34.3305 41.8482 34.4847 41.9354 34.6244C42.0226 34.7642 42.1243 34.8943 42.2502 35.0195C42.3763 35.1449 42.507 35.2508 42.6475 35.3328C42.788 35.4195 42.943 35.482 43.1126 35.5303C43.2822 35.5785 43.4614 35.5978 43.6455 35.5978V35.5978Z"
                            fill="#27293d"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="43"
                          height="43"
                          viewBox="0 0 68 68"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M30.7139 61.3965C30.2097 61.3965 29.7597 61.2384 29.3639 60.9281C28.7892 60.4812 28.5018 59.8984 28.5018 59.1683V10.2283C28.5018 9.50366 28.7892 8.91527 29.3639 8.46853C29.765 8.158 30.2152 8 30.7139 8C30.9037 8 31.099 8.0272 31.2886 8.08719L53.4271 12.5383C53.5898 12.5655 53.7307 12.6146 53.8608 12.6745C53.9855 12.7344 54.0831 12.7835 54.159 12.8325C54.2349 12.876 54.3054 12.936 54.3813 13.0123C54.4572 13.0886 54.5061 13.1485 54.5386 13.192L54.6742 13.3936C54.9399 13.7804 55.07 14.2108 55.07 14.6848V54.7281C55.07 55.3383 54.929 55.8014 54.647 56.1283C54.3054 56.526 53.9043 56.7711 53.4271 56.8638L31.2886 61.3148C31.0935 61.3693 30.9037 61.3965 30.7139 61.3965V61.3965ZM17.4298 56.9455C16.2044 56.9455 15.158 56.5096 14.2959 55.6433C13.4338 54.7771 13 53.7257 13 52.4944V16.9022C13 15.6709 13.4338 14.6194 14.2959 13.7532C15.158 12.8869 16.2044 12.4511 17.4298 12.4511H26.2841V16.9022H17.4298V52.4943H26.2841V56.9455H17.4298ZM36.2445 35.8125C36.8517 35.8125 37.3723 35.5945 37.8061 35.1586C38.2399 34.7229 38.4567 34.1997 38.4567 33.5896C38.4567 33.1918 38.3591 32.816 38.1585 32.4781C37.9579 32.1349 37.6922 31.8679 37.3506 31.6665C37.009 31.4649 36.6402 31.3668 36.2445 31.3668C35.8432 31.3668 35.4746 31.4649 35.1384 31.6665C34.7968 31.8679 34.5311 32.1349 34.3304 32.4781C34.1298 32.8215 34.0322 33.1918 34.0322 33.5896C34.0322 33.7967 34.0594 33.9981 34.1081 34.1889C34.1623 34.3795 34.2329 34.5539 34.3305 34.7119C34.4281 34.8699 34.5419 35.017 34.6829 35.1586C34.824 35.3004 34.9702 35.4201 35.1275 35.5128C35.2848 35.6109 35.4582 35.6816 35.6481 35.7361C35.8378 35.7906 36.0385 35.8124 36.2445 35.8124L36.2445 35.8125Z"
                            fill="white"
                          />
                        </svg>
                      )
                    ) : (
                      <svg
                        width="43"
                        height="43"
                        viewBox="0 0 68 68"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M30.7139 61.3965C30.2097 61.3965 29.7597 61.2384 29.3639 60.9281C28.7892 60.4812 28.5018 59.8984 28.5018 59.1683V10.2283C28.5018 9.50366 28.7892 8.91527 29.3639 8.46853C29.765 8.158 30.2152 8 30.7139 8C30.9037 8 31.099 8.0272 31.2886 8.08719L53.4271 12.5383C53.5898 12.5655 53.7307 12.6146 53.8608 12.6745C53.9855 12.7344 54.0831 12.7835 54.159 12.8325C54.2349 12.876 54.3054 12.936 54.3813 13.0123C54.4572 13.0886 54.5061 13.1485 54.5386 13.192L54.6742 13.3936C54.9399 13.7804 55.07 14.2108 55.07 14.6848V54.7281C55.07 55.3383 54.929 55.8014 54.647 56.1283C54.3054 56.526 53.9043 56.7711 53.4271 56.8638L31.2886 61.3148C31.0935 61.3693 30.9037 61.3965 30.7139 61.3965V61.3965ZM17.4298 56.9455C16.2044 56.9455 15.158 56.5096 14.2959 55.6433C13.4338 54.7771 13 53.7257 13 52.4944V16.9022C13 15.6709 13.4338 14.6194 14.2959 13.7532C15.158 12.8869 16.2044 12.4511 17.4298 12.4511H26.2841V16.9022H17.4298V52.4943H26.2841V56.9455H17.4298ZM36.2445 35.8125C36.8517 35.8125 37.3723 35.5945 37.8061 35.1586C38.2399 34.7229 38.4567 34.1997 38.4567 33.5896C38.4567 33.1918 38.3591 32.816 38.1585 32.4781C37.9579 32.1349 37.6922 31.8679 37.3506 31.6665C37.009 31.4649 36.6402 31.3668 36.2445 31.3668C35.8432 31.3668 35.4746 31.4649 35.1384 31.6665C34.7968 31.8679 34.5311 32.1349 34.3304 32.4781C34.1298 32.8215 34.0322 33.1918 34.0322 33.5896C34.0322 33.7967 34.0594 33.9981 34.1081 34.1889C34.1623 34.3795 34.2329 34.5539 34.3305 34.7119C34.4281 34.8699 34.5419 35.017 34.6829 35.1586C34.824 35.3004 34.9702 35.4201 35.1275 35.5128C35.2848 35.6109 35.4582 35.6816 35.6481 35.7361C35.8378 35.7906 36.0385 35.8124 36.2445 35.8124L36.2445 35.8125Z"
                          fill="white"
                        />
                      </svg>
                    )}

                    <p className="m-0">{t("dashboard.door")}</p>
                  </div>
                </div>
                {userInfo &&
                userInfo.userInfo &&
                userInfo.userInfo.email === "demo@lariantech.com" ? (
                  <div
                    className={`d-flex  flex-column justify-content-center ${classNames(
                      {
                        op03: this.lessthanData(latestData, basicData, {
                          name: "ln2lvl",
                          value: 2,
                          main: false,
                          error:
                            this.props.devices &&
                            this.props.devices.length > 0 &&
                            filteredBasicData &&
                            filteredBasicData.length > 0 &&
                            (filteredBasicData[0].ln2lvl ||
                              filteredBasicData[0].ln2lvl === 0)
                              ? filteredBasicData[0].ln2lvl === -255
                                ? true
                                : false
                              : true,
                        }),
                      }
                    )}`}
                  >
                    <div
                      className={`custom_iconbox d-flex  align-items-center `}
                    >
                      <svg
                        version="1.0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="43"
                        height="43"
                        viewBox="0 0 270.000000 321.000000"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g
                          transform="translate(0.000000,321.000000) scale(0.100000,-0.100000)"
                          fill="#fff"
                          stroke="none"
                        >
                          <path
                            d="M1010 3054 c-365 -43 -644 -156 -696 -281 -20 -46 -20 -470 0 -516
31 -76 170 -162 340 -211 98 -29 262 -61 356 -71 l65 -7 0 79 c1 88 12 117 70
175 109 108 298 85 380 -46 27 -45 30 -57 30 -133 l0 -84 55 6 c431 47 719
153 784 289 24 50 24 472 0 522 -62 129 -329 234 -714 279 -156 19 -512 18
-670 -1z"
                          />
                          <path
                            d="M1275 2251 c-102 -25 -165 -104 -165 -206 0 -120 85 -205 205 -205
100 0 182 64 205 161 34 141 -105 283 -245 250z"
                          />
                          <path
                            d="M1440 1776 c-95 -70 -164 -72 -247 -6 -65 51 -162 0 -149 -79 3 -25
17 -47 46 -73 118 -106 322 -105 444 3 41 36 46 45 46 83 0 79 -76 119 -140
72z"
                          />
                          <path
                            d="M959 1495 c-32 -18 -54 -66 -45 -102 9 -34 76 -95 147 -133 185 -98
423 -75 587 57 77 62 90 129 35 173 -41 32 -83 26 -141 -20 -101 -80 -200
-104 -312 -76 -36 9 -81 28 -100 42 -19 13 -50 36 -69 49 -38 28 -64 31 -102
10z"
                          />
                          <path
                            d="M1669 1179 c-228 -183 -502 -182 -714 1 -61 52 -110 56 -149 9 -16
-18 -26 -43 -26 -62 0 -75 208 -215 375 -252 110 -25 272 -17 380 18 98 32
188 85 260 152 48 44 55 56 55 89 0 28 -7 45 -29 67 -44 44 -76 39 -152 -22z"
                          />
                          <path
                            d="M1922 916 c-112 -100 -207 -154 -352 -201 -104 -34 -299 -45 -414
-25 -159 28 -318 104 -439 210 -56 49 -75 60 -103 60 -48 0 -94 -45 -94 -91 0
-60 144 -182 318 -268 376 -188 857 -127 1177 149 102 90 119 137 66 191 -47
47 -85 41 -159 -25z"
                          />
                          <path
                            d="M2340 673 c-204 -182 -419 -297 -670 -357 -494 -120 -1009 11 -1392
354 -62 56 -77 65 -111 65 -50 0 -87 -39 -87 -90 0 -41 33 -81 134 -164 222
-181 472 -301 756 -363 93 -20 133 -22 340 -22 206 0 247 2 335 22 309 69 571
200 801 401 104 90 122 123 100 176 -17 39 -42 55 -88 55 -27 -1 -49 -15 -118
-77z"
                          />
                        </g>
                      </svg>

                      <p className="m-0">
                        {this.props.devices &&
                        this.props.devices.length > 0 &&
                        filteredBasicData &&
                        filteredBasicData.length > 0 &&
                        (filteredBasicData[0].ln2lvl ||
                          filteredBasicData[0].ln2lvl === 0)
                          ? filteredBasicData[0].ln2lvl === -255
                            ? "N/A"
                            : `${Number(filteredBasicData[0].ln2lvl).toFixed(
                                2
                              )} %`
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                ) : (
                  this.waterIcon(filteredBasicData)
                )}
              </div>
            )}
          </>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locations: state.locationsDevices.locations,
    pagedDeviceDataList: state.locationsDevices.pagedDeviceDataList,
    devices: state.locationsDevices.devices,
    pagedDeviceMeta: state.locationsDevices.pagedDeviceMeta,
    deviceStatusData: state.dashboard.deviceStatus,
    userInfo: state.dashboard.dashboard,
    temperatureUnit: state.auth.temperatureUnit,
  };
};

export default connect(mapStateToProps)(
  translate("translations")(DeviceStatus)
);
